import {
  UpdateRatecardClientMapping,
  UpdateRatecardValue,
} from "../dtos/UpdateRateCardRequest";
import { UpdateRouteRateUIRequest } from "../routeRate/UpdateRouteRateModal";
import { StoreRateCardAssociationResponse } from "../dtos/StoreRatecardAssociationResponse";

export const mapValuesUiRequestToUpdateRatecardValue = (
  uiRequest: UpdateRouteRateUIRequest
): UpdateRatecardValue => {
  // handle RATECARD VALUES
  const updateRatecardValue: UpdateRatecardValue = {
    id: uiRequest.values_id ?? undefined,
    baseRate: uiRequest.baseRate !== undefined ? uiRequest.baseRate : 0,
    variableRate:
      uiRequest.variableRate !== undefined ? uiRequest.variableRate : 0,
    variableRateType: uiRequest.variableRateType,
    routeMinimum:
      uiRequest.routeMinimum !== undefined ? uiRequest.routeMinimum : 0,
    lateCancellationCharge:
      uiRequest.lateCancellationCharge !== undefined
        ? uiRequest.lateCancellationCharge
        : 0,
    lateCancellationType: uiRequest.lateCancellationType,
    fuelType: uiRequest.show_fuel_surcharge
      ? uiRequest.show_fuel_surcharge
        ? uiRequest.fuelType
        : undefined
      : undefined,
    regionName: uiRequest.show_fuel_surcharge
      ? uiRequest.show_fuel_surcharge
        ? uiRequest.regionName
        : undefined
      : undefined,
  };

  // handle discounts
  if (uiRequest.show_discount) {
    updateRatecardValue.discountType =
      uiRequest.discount_type === "volume"
        ? "volume"
        : uiRequest.discount_rate_type;
    // handle volume discount
    if (uiRequest.discount_type === "volume") {
      updateRatecardValue.discountMinVolumeRate =
        uiRequest.discount_volume_min_unit;
      updateRatecardValue.discountFrequency = mapFrequencyTextToNumber(
        `${uiRequest.discount_volume_frequency}`
      );
      if (uiRequest.discount_volume_unit_type === "percentage") {
        updateRatecardValue.discountUnitType = "percentage";
        updateRatecardValue.discountValue =
          uiRequest.discount_volume_value_percentage;
      } else {
        updateRatecardValue.discountUnitType = "value";
        updateRatecardValue.discountValue =
          uiRequest.discount_volume_value_dollar;
      }
    }
    // handle rate discount
    else if (uiRequest.discount_type === "rate") {
      updateRatecardValue.discountMinVolumeRate =
        uiRequest.discount_rate_min_unit;

      updateRatecardValue.discountFrequency = mapFrequencyTextToNumber(
        `${uiRequest.discount_rate_frequency}`
      );
      if (uiRequest.discount_rate_unit_type === "percentage") {
        updateRatecardValue.discountUnitType = "percentage";
        updateRatecardValue.discountValue =
          uiRequest.discount_rate_value_percentage;
      } else {
        updateRatecardValue.discountUnitType = "value";
        updateRatecardValue.discountValue =
          uiRequest.discount_rate_value_dollar;
      }
    }
  }

  return updateRatecardValue;
};

const mapFrequencyTextToNumber = (frequency: string): number => {
  return frequency === "weekly" ? 7 : frequency === "bi-weekly" ? 14 : 30;
};

export const mapFrequencyNumberToText = (
  frequency: number | undefined
): string => {
  if (frequency === undefined) return "";
  return frequency === 7
    ? "weekly"
    : frequency === 14
    ? "bi-weekly"
    : "monthly";
};

export const mapClientMappingsResponseToStringList = (
  mappings: UpdateRatecardClientMapping[] | undefined
): string[] => {
  if (mappings && mappings.length > 0) {
    return mappings.map((mapping) => {
      if (mapping.storeId && mapping.storeName) return mapping.storeName;
      return `${mapping.parcelCenterName}`;
    });
  }
  return [];
};

export const getStoreMappingFromStoreName = (
  clientId: number,
  storeName: string,
  mappings: UpdateRatecardClientMapping[] | undefined,
  storeAssociationList: StoreRateCardAssociationResponse[]
): UpdateRatecardClientMapping | null => {
  const storeMapping = mappings?.find(
    (mapping) => mapping.storeName === storeName
  );

  if (storeMapping) {
    return storeMapping;
  } else {
    const storeAssociation = storeAssociationList?.find(
      (association) => association.storeId === storeName
    );
    if (storeAssociation) {
      return {
        storeId: storeAssociation.id,
        storeName: storeAssociation.storeId,
        clientId: clientId,
        isAssociated: true,
      };
    }
    return null;
  }
};